import React, { useEffect, useState } from "react";
import { NoData, TableAdv } from "../../../../../components";
import { getClientId, getEmployeeId, mapTableRows } from "../../../../../utils";
import { dateFormator, formatWords } from "../../../../../utils";
import StatusTags from "../../../../../components/Tags/StatusTags";
import axiosRequest from "../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../redux/apiConfig";
import { useSelector } from "react-redux";
import { formatCurrency, formatWords2 } from "../../../../../utils/stringUtils";
import { usePagination } from "../../../../../hooks";

const BonusPayments = () => {
  const { employeeProfileUiid } = useSelector((state) => state?.employee);
  console.log("employeeProfileUiid", employeeProfileUiid);
  const [bonuses, setBonuses] = useState([]);
  const [placements, setPlacements] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    25,
    (newPage, newLimit) => {}
  );
  const columns = [
    //cant show employeID because already viewing in his bonus payment sections
    // {
    //   key: "employeeId",
    //   label: "Employee ID",
    //   render: (row) => <span className="text-linkblue">{row.employeeId}</span>,
    // },
    {
      key: "jobId",
      label: "Job Code",
      render: (row) => <span>{row?.jobId?.jobInfo?.jobCode}</span>,
    },
    {
      key: "referredId",
      label: "Candidate Name",
      render: (row) => (
        <span>{`${[row.referredId?.firstName, row.referredId?.lastName]
          .filter(Boolean)
          .join(" ")} (${getEmployeeId(
          row?.referredId?.uiid,
          row?.referredId?.employmentType
        )})`}</span>
      ),
    },

    {
      key: "jobId1",
      label: "Project",
      render: (row) => <span>{row?.jobId?.jobInfo?.jobTitle}</span>,
    },

    {
      key: "period",
      label: "Period",
      render: (row) => (
        <span>
          {dateFormator(row.period.from, "month-day-year")} -{" "}
          {dateFormator(row.period.to, "month-day-year")}
        </span>
      ),
    },
    {
      key: "bonusAmt",
      label: "Bonus Amount",
      render: (row) => <span>{formatCurrency(row.bonusAmt)}</span>,
    },

    {
      key: "status",
      label: "Status",
      render: (row) => (
        <StatusTags
          tag={formatWords(
            "",
            row?.status === 1
              ? "Unpaid"
              : row?.status === 2
              ? "In Progress"
              : row?.status === 3
              ? "Paid"
              : "Skipped"
          )}
        />
      ),
    },

    {
      key: "bonusAmt1",
      label: "Total Balance",
      render: (row) => <span>{formatCurrency(row.balanceAmt)}</span>,
    },
    {
      key: "paidOn",
      label: "Paid On",
      render: (row) =>
        row.paidOn ? dateFormator(row.paidOn, "month-day-year") : "-",
    },
    {
      key: "linkedPayroll",
      label: "Linked Payroll",
      render: (row) => (
        <span>
          {row?.usage?.payrollId ? "Linked With Payroll" : "-" || "-"}
        </span>
      ),
    },
  ];
  const columns2 = [
    {
      key: "employeeId",
      label: "Referred Employees",
      render: (row) => (
        <span className="text-linkblue">
          {row?.employeeId?.firstName +
            " " +
            row?.employeeId?.lastName +
            " (" +
            getEmployeeId(
              row?.employeeId?.uiid,
              row?.employeeId?.employmentType
            ) +
            ")"}
        </span>
      ),
    },
    {
      key: "client",
      label: "Client Business Name",
      render: (row) => (
        <span>
          {row?.jobInfo?.billClient?.businessName ||
            "-" + " (" + getClientId(row?.jobInfo?.billClient?.uiid) + ")"}
        </span>
      ),
    },
    {
      key: "employeeId",
      label: "Job Title",
      render: (row) => <span>{formatWords2(row?.jobInfo?.jobTitle)}</span>,
    },
    {
      key: "referralamount",
      label: "Margin Amount",
      render: (row) => (
        <span>
          {row?.lastPay?.referral?.[0].margin
            ? formatCurrency(row?.lastPay?.referral?.[0].margin)
            : "-"}
        </span>
      ),
    },
    {
      key: "referralamount",
      label: "Referral Amount",
      render: (row) => (
        <span>
          {row?.lastPay?.referral?.[0].margin
            ? formatCurrency(row?.lastPay?.referral?.[0].referralAmount)
            : row?.lastPay?.referral?.[0].referralAmountType === 2
            ? `${row?.lastPay?.referral?.[0].referralAmount}%`
            : formatCurrency(row?.lastPay?.referral?.[0].referralAmount)}
        </span>
      ),
    },
    {
      key: "billratetype",
      label: "Billing Type",
      render: (row) => (
        <span>
          {row?.lastPay?.billRate?.type === 1
            ? "Hourly"
            : row?.lastPay?.billRate?.type === 2
            ? "Daily"
            : row?.lastPay?.billRate?.type === 3
            ? "Weekly"
            : row?.lastPay?.billRate?.type === 4
            ? "Monthly"
            : row?.lastPay?.billRate?.type === 5
            ? "Yearly"
            : "Unknown"}
        </span>
      ),
    },
  ];

  useEffect(() => {
    const fetchBonuses = async () => {
      let filter = {
        employeeId: { type: "NONE", value: employeeProfileUiid },
      };
      let filter2 = {
        // uiid: {
        //   type: "NONE",
        //   value: vendorId,
        // },
        employeeId: {
          type: "AG_REFERRAL",
          value: ["Active", employeeProfileUiid],
        },
      };
      const response = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.EMPLOYEE_BONUS.GET_ALL,
        params: {
          coll: "EmpBonusPay",
          ref: "ReferredId Placement",
          incl: ["firstName lastName employmentType uiid", "jobInfo"],
          fil: JSON.stringify(filter),
          lim: limit,
          pg: page,
        },
      });
      const response1 = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.PLACEMENTS.GET_ALL,
        params: {
          lim: 100,
          pg: 1,
          coll: "Placement",
          fil: JSON.stringify(filter2),
          useAggregate: true,
          // se
          ret: "jobInfo.billClient.businessName jobInfo.billClient.uiid jobInfo.endDate jobInfo.jobTitle clientPlacement.placement employeeId.firstName employeeId.lastName employeeId.uiid employeeId.employmentType",
          ref: "Employee",
        },
      });
      setBonuses(response?.data?.data || []);
      setPlacements(response1?.data?.data || []);
      console.log("response for placements", response1?.data?.data || []);
      const total = await axiosRequest({
        method: "GET",
        url: ENDPOINTS.EMPLOYEE_BONUS.GET_TOTAL_COUNT,
        params: {
          coll: "EmpBonusPay",
          fil: JSON.stringify(filter),
          // lim: limit,
          // pg: page,
        },
      });
      console.log("total for bonus", total?.data?.data || 10);
      setTotalCount(total?.data?.data || 0);
    };
    if (employeeProfileUiid) {
      fetchBonuses();
    }
  }, [limit, page]);
  const mappedRows = mapTableRows(bonuses, columns);
  const mappedRows2 = mapTableRows(placements, columns2);

  if (mappedRows2.length === 0 && mappedRows.length === 0)
    return <NoData desc="No Bonus Payments Found" />;

  return (
    <>
      {mappedRows2.length > 0 && (
        <div className="p-[7px] mt-[18px] mb-4 rounded-tr-sm rounded-br-sm cursor-pointer">
          <div className="font-semibold mb-4">Employee Referred Placements</div>
          <div>
            <TableAdv
              tableId={`Employee_payments_bonuspayments_employeerefertable`}
              columns={columns2}
              rows={mappedRows2}
              totalCount={100}
              hideToolBar={true}
              />
          </div>
        </div>
      )}
      {mappedRows.length > 0 && (
        <div className="p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
          <div className="font-semibold mb-4">Bonus Payments</div>
          <div>
            <TableAdv
              tableId={`Employee_payments_bonuspayments`}
              columns={columns}
              rows={mappedRows}
              serverPagination={true}
              totalCount={totalCount}
              page={page}
              limit={limit}
              onPaginationChange={setPage}
              onLimitChange={handleLimitChange}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default BonusPayments;
